module.exports = {
  title: 'Firman Jabar',
  description: 'FE Dev',
  keywords: 'firman, abdul, jabar, firmanjabar, firmanabduljabar',
  url: 'https://firmanjabar.my.id',
  twitter: '@firmanjabar',
  // seoImage: "https://soulextract.com/images/soulextract.jpg",
  color: '#000000',
};
